import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import FreeConsultationPopup from './FreeConsultationPopup';
import ConvertToScheduleConsultation from './FreeConsultation/ConvertToScheduleConsultation';
class FreeConsultation extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:'',
      open_popup:'',
    };
  }

  view_table_row(table_data){
    let cutThis = this;
    var all_table_row = [];
    var nu = 1;
    for(var data in table_data){
      var id              = table_data[data]['id'];
      var subject_matter  = table_data[data]['subject_matter'];
      var added_date      = table_data[data]['added_date'];
      var write_flag      = table_data[data]['write_flag'];
      var action_flag     = table_data[data]['action_flag'];
      var first_name      = table_data[data]['first_name'];
      var last_name       = table_data[data]['last_name'];
      var email           = table_data[data]['email'];
      var mobile_no       = table_data[data]['mobile_no'];
      var status          = ['Inactive','Active','End'];
      var view_icon = <span className="pointer" onClick={cutThis.open_view_popup.bind(cutThis,id)} title="View"><i class="fa fa-eye me-1"></i></span>;
      var schedule_icon = <span className="pointer" onClick={cutThis.open_add_to_schedule_popup.bind(cutThis,id,first_name,last_name,email,mobile_no)} title="Add to Schedule"><i class="fa fa-user-clock"></i></span>;
      //if(action_flag==0){view_icon = <span className="pointer" onClick={cutThis.active_view_popup.bind(cutThis,id)} title="Active"><i class="fa fa-check-square" aria-hidden="true"></i></span>;}
      all_table_row.push(
        <tr id={nu}>
        <th scope="row">{nu}</th>
        <td>{subject_matter}</td>
        <td>{first_name+" "+last_name}</td>
        <td>{email}</td>
        <td>{mobile_no}</td>
        <td>{added_date}</td>
        <td>{status[action_flag]}</td>
        <td>{view_icon}</td>
        <td>{schedule_icon}</td>
        </tr>
      );
      nu++;
    }
    cutThis.setState({all_table_row});
  }

active_view_popup(id){

}
open_add_to_schedule_popup(id,first_name,last_name,email,mobile_no){
  var open_popup = <ConvertToScheduleConsultation id={id} email={email} mobile_no={mobile_no} first_name={first_name} last_name={last_name} close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({open_popup});
  setTimeout(function (){window.model_show();},100);
}

open_view_popup(id){
  var open_popup = <FreeConsultationPopup id={id} close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({open_popup});
  setTimeout(function (){window.model_show();},100);
}
close_popup(){
  window.model_hide();
  var open_popup = '';
  this.setState({open_popup});
  this.getFreeConsultation();
}
componentDidMount(){
  this.getFreeConsultation();
}
getFreeConsultation(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','get_free_consultation_data');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
     }else{
       url = "/php/admin_free_consultation_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var data = res.data;
        if(data['code']==1){
          cutThis.view_table_row(data['msg']);
        }else{
          //window.location.href = '/';
        }

      })
      .catch(function (error) {
          console.log(error);
      });
}

  render() {
    return (
        <>
        <DashboardHeading title="Free Consultation"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Free Consultation</h3>
                <div className="row g-4">
                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Subject Matter</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Added Date</th>
                <th scope="col">Status</th>
                <th scope="col" colSpan="2">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
        </div>
        {this.state.open_popup}
        </>
    );
  }
}

export default FreeConsultation;
